import df from './date-format-filter'

export default {
    dateFormat: df.dateFormat,
    dateInterval: df.dateInterval
}